import Service from '../abstract/service'

export default class Menus extends Service {
  constructor() {
    super()
    this._menusCollection = this._db.collection(`Menus`)
  }

  async list() {
    try {
      let menus = new Array()
      const response = await this._menusCollection.get()

      if(!response.empty) {
        for(let doc of response.docs) {
          menus.push({
            ...doc.data()
          })
        }
      }

      return Promise.resolve(menus)
    } catch(error) {
      return Promise.reject(error)
    }
  }
}
